import { render, staticRenderFns } from "./StudentFaceIcon.vue?vue&type=template&id=f71bea24&scoped=true&lang=pug&"
import script from "./StudentFaceIcon.vue?vue&type=script&lang=ts&"
export * from "./StudentFaceIcon.vue?vue&type=script&lang=ts&"
import style0 from "./StudentFaceIcon.vue?vue&type=style&index=0&id=f71bea24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71bea24",
  null
  
)

export default component.exports